import { createFileRoute } from "@tanstack/react-router"

import { QrScanPage } from "@/pages/share/qr-scan-page"

export const Route = createFileRoute("/q/$token")({
	component: QrScanPage,
})
